// Życzonka: koszyk boczny (Shopify Ajax Cart API), wspólny dla strony głównej i karty produktu.
(() => {
  const money = (cents, cur = 'PLN') => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const root = () => window.Shopify?.routes?.root || '/';

  function init() {
    // próg darmowej dostawy kurierem jak w Rynki → Polska (175 zł, w groszach)
    const FREE_SHIPPING = 17500;
    const SINGLE = 3900; // cena pojedynczej bombki, do podpowiedzi ile dobrać
    const howMany = left => {
      const n = Math.ceil(left / SINGLE);
      if (n === 1) return 'Dobierz jeszcze jedną bombkę.';
      const word = n < 5 ? 'bombki' : 'bombek';
      return n >= 3 ? `Dobierz jeszcze ${n} ${word} albo komplet 4 bombek.` : `Dobierz jeszcze ${n} ${word}.`;
    };
    const cart = document.querySelector('.v2-cart'); if (!cart) return;
    const list = cart.querySelector('.v2-cart-list'), sum = cart.querySelector('.ct-sum');
    const node = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
    const lineBtn = (cls, text, line, quantity, label) => { const b = node('button', cls, text); b.type = 'button'; b.dataset.line = line; b.dataset.quantity = quantity; if (label) b.setAttribute('aria-label', label); return b; };
    function lineRow(i, line, c) {
      const row = node('div', 'ct-row');
      const pic = node('a', 'ct-img'); pic.href = i.url;
      if (i.image) { const img = new Image(120, 160); const u = new URL(i.image, location.href); u.searchParams.set('width', '240'); img.src = u; img.alt = i.product_title; pic.append(img); }
      const name = node('div', 'ct-name'); const link = node('a', '', i.product_title); link.href = i.url; name.append(link);
      if (i.variant_title) name.append(node('span', '', i.variant_title));
      name.append(lineBtn('ct-remove', 'Usuń', line, 0));
      const qty = node('div', 'ct-qty'); qty.setAttribute('role', 'group'); qty.setAttribute('aria-label', `Ilość: ${i.product_title}`);
      qty.append(lineBtn('', '−', line, i.quantity - 1, 'Mniej'), node('span', '', i.quantity), lineBtn('', '+', line, i.quantity + 1, 'Więcej'));
      row.append(pic, name, qty, node('div', 'ct-price', money(i.final_line_price, c.currency)));
      return row;
    }
    function draw(c) {
      document.querySelectorAll('.bag-count').forEach(b => { b.textContent = `(${c.item_count})`; });
      list.replaceChildren(...c.items.map((i, n) => lineRow(i, n + 1, c)));
      if (!c.item_count) list.textContent = 'Twój koszyk jest jeszcze pusty.';
      sum.hidden = !c.item_count;
      const left = FREE_SHIPPING - c.total_price;
      sum.querySelector('.ct-ship').textContent = left > 0 ? `Brakuje ${money(left, c.currency)} do darmowej dostawy kurierem. ${howMany(left)}` : 'Masz darmową dostawę kurierem.';
      sum.querySelector('[data-cart-komplet]').hidden = c.item_count > 3 || c.items.some(i => i.handle === 'kolekcja-4-bombek');
      sum.querySelector('[data-cart-total]').textContent = money(c.total_price, c.currency);
    }
    async function refresh() {
      if (!window.Shopify) return;
      try { draw(await (await fetch(root() + 'cart.js')).json()); }
      catch { list.textContent = 'Nie udało się odczytać koszyka.'; }
    }
    list.addEventListener('click', async e => {
      const b = e.target.closest('button[data-line]'); if (!b) return;
      list.querySelectorAll('button').forEach(x => { x.disabled = true; });
      try {
        const r = await fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.quantity) }) });
        if (!r.ok) throw Error();
        draw(await r.json());
      } catch { await refresh(); }
    });
    const openCart = () => { if (!cart.open) cart.showModal(); };
    document.querySelector('[data-cart]')?.addEventListener('click', () => { refresh(); openCart(); });
    cart.querySelector('.v2-close').addEventListener('click', () => cart.close());
    cart.querySelector('[data-cart-more]').addEventListener('click', () => cart.close());
    cart.addEventListener('click', e => { if (e.target === cart) cart.close(); });
    window.zyCart = { open: openCart, refresh };
    refresh();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
